import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getPatientInfoKey } from 'infrastructure/hooks/patient/use-patient-info';
import { showResult } from 'infrastructure/hooks/utils';

import { updatePatientApcmStatusFn } from './api';

import type { IPatient } from 'infrastructure/interfaces';

export const useUpdatePatientApcmStatus = () => {
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation({
    mutationFn: updatePatientApcmStatusFn,
    onSuccess(data, { patientGuid, apcmStatus }) {
      const patientInfoKey = getPatientInfoKey(patientGuid);
      queryClient.setQueryData<IPatient>(patientInfoKey, (oldData) => {
        if (oldData) {
          return {
            ...oldData,
            apcmStatus,
          };
        }
      });
      showResult();
    },
  });

  return { updateApcmStatus: mutate, apcmStatusLoading: isLoading };
};
